// noinspection JSDeprecatedSymbols

export class Browser
{
    // analyze browser engine, os and mobile
    static analyze()
    {
        Browser.mobile = false;

        // noinspection JSUnresolvedVariable
        if(navigator.userAgentData)
        {
            // noinspection JSUnresolvedVariable
            navigator.userAgentData.brands.forEach(brand => {
                // noinspection JSUnresolvedVariable
                if(brand.brand === 'Chromium')
                {
                    Browser.engine = 'blink';
                    Browser.version = parseInt(brand.version);
                }
            });

            if(Browser.engine)
            {
                Browser.mobile = navigator.userAgentData.mobile;
                // noinspection JSDeprecatedSymbols
                switch(navigator.userAgentData.platform.toLowerCase())
                {
                    case "windows":
                        Browser.os = 'windows';
                        break;

                    case "macintel":
                    case "macos":
                        Browser.os = Browser.mobile ? 'ios' : 'osx';
                        break;

                    case "android":
                        Browser.os = 'android';
                        break;

                    case "linux":
                        Browser.os = 'linux';
                        break;
                }
            }
        }

        if(!Browser.engine)
        {
            if(navigator.vendor && navigator.vendor.match(/google/i))
            {
                Browser.engine = 'blink';
                Browser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9]\d*)\..*$/i,
                    '$1'));
            }
            else if(navigator.vendor && navigator.vendor.match(/apple/i))
            {
                Browser.engine = 'webkit';
                Browser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9]\d*(\.[1-9])?).*$/i,
                    '$1'));
            }
            else if(navigator.userAgent.match(/firefox\//i))
            {
                Browser.engine = 'gecko';
                Browser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9]\d*)\..*$/i,
                    '$1'));
            }
            else if(navigator.userAgent.match(/edge\//i))
            {
                Browser.engine = 'edgehtml';
                Browser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9]\d*)\..*$/i,
                    '$1'));
            }
            else if(navigator.userAgent.match(/trident\//i))
            {
                Browser.engine = 'trident';
                Browser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9]\d*)\..*$/i,
                    '$1')) + 4;
            }

            Browser.touchscreen = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

            // noinspection JSDeprecatedSymbols
            switch(navigator.platform.toLowerCase())
            {
                case 'win32':
                    Browser.os = 'windows';
                    break;

                case 'macintel':
                    // detect iOS on iPadOS/Safari 13
                    if(navigator.maxTouchPoints > 1)
                    {
                        Browser.os = 'ios';
                        Browser.mobile = true;
                    }
                    else
                    {
                        Browser.os = 'osx';
                    }
                    break;

                case 'ipad':
                case 'iphone':
                    Browser.os = 'ios';
                    Browser.mobile = true;
                    break;

                default:
                    if(navigator.userAgent.match(/android/i))
                    {
                        Browser.os = 'android';
                        Browser.mobile = true;
                    }

                    else if(navigator.platform.match(/linux/i))
                    {
                        Browser.os = 'linux';
                    }
            }
        }
    }
}